import { Component } from '@angular/core';
import {AppMenuComponent} from '@layouts/components/navbar/components/app-menu/app-menu.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-navbar',
    imports: [
        AppMenuComponent,
        TranslateModule

    ],
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  

}
